export default "__VITE_ASSET__BrTQ1eYF__"